/**
 * CRM service — company-scoped leads/contacts + outreach.
 * All calls go through the shared `api` axios instance (auth token attached).
 */
import api from './api';

class CrmService {
  async listContacts({ status, source, q, page = 1, pageSize = 25 } = {}) {
    const params = { page, page_size: pageSize };
    if (status) params.status = status;
    if (source) params.source = source;
    if (q) params.q = q;
    const res = await api.get('/api/crm/contacts', { params });
    return res.data;
  }

  async getContact(id) {
    const res = await api.get(`/api/crm/contacts/${id}`);
    return res.data;
  }

  async updateContact(id, body) {
    const res = await api.patch(`/api/crm/contacts/${id}`, body);
    return res.data;
  }

  async logActivity(id, type, text) {
    const res = await api.post(`/api/crm/contacts/${id}/activities`, { type, body: text });
    return res.data;
  }

  async sendEmail(id, subject, body) {
    const res = await api.post(`/api/crm/contacts/${id}/email`, { subject, body });
    return res.data;
  }

  async analytics(days = 30) {
    const res = await api.get('/api/crm/analytics', { params: { days } });
    return res.data;
  }

  async downloadCsv({ status, source } = {}) {
    const params = {};
    if (status) params.status = status;
    if (source) params.source = source;
    const res = await api.get('/api/crm/contacts/export.csv', { params, responseType: 'blob' });
    const url = window.URL.createObjectURL(new Blob([res.data], { type: 'text/csv' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = 'leads.csv';
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }
}

const crmService = new CrmService();
export default crmService;
